export default "__VITE_ASSET__zqVmwoON__"